module.exports = __webpack_public_path__ + "img/logo_white.c7485f4c.png";